import { AppThunk } from '../../../store/rootReducer';
import {
  baseClustersSelector,
  projectedBaseClusterSelector,
} from '../selectors/cluster.selectors';
import { selectNewCluster } from './select-new-cluster.thunk';

export const selectNextBaseCluster =
  (): AppThunk => async (dispatch, getState) => {
    const selectedCluster = projectedBaseClusterSelector(getState());
    const clusters = baseClustersSelector(getState());

    if (selectedCluster != null) {
      const currIndex = clusters.findIndex(
        (cluster) => cluster.id === selectedCluster.id,
      );

      if (clusters[currIndex + 1] != null) {
        const newSelectedCluster = clusters[currIndex + 1];
        dispatch(selectNewCluster(newSelectedCluster));
      }
    }
  };
